import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class LangRouterService {
  private translateService = inject(TranslateService);
  private router = inject(Router);
  private location = inject(Location);

  get currentLang(): string {
    return this.translateService.currentLang ?? this.translateService.defaultLang ?? 'de';
  }

  /** Returns path prefixed with current language: '/categories' → '/de/categories' */
  translateRoute(path: string): string {
    return '/' + this.currentLang + path;
  }

  /** Changes language and navigates to the same page with new language prefix */
  changeLanguage(lang: string): void {
    const currentPath = this.location.path();
    const segments = currentPath.split('/');
    // segments[0] = '', segments[1] = lang, rest = path
    segments[1] = lang;
    const newPath = segments.join('/') || '/' + lang;
    this.translateService.use(lang).subscribe(() => {
      this.router.navigateByUrl(newPath);
    });
  }
}
